import { Component } from '@angular/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
/**
 * Onboarding template to be filled when instantiated
 */
export class RegisterComponent {}
